export default "__VITE_ASSET__qKY6HAoD__"